import { DEFAULT_COMPLETE_PROFILE_STEP_ORDER, PROFILE_STEP_TYPE } from './ProfileStep';
import { EXCLUDED_PROFILING_SOCIAL_MEDIA_PLATFORM, SOCIAL_MEDIA_PLATFORM } from './SocialMediaPlatform';
var isProduction = process.env.REACT_APP_PARTIPOST_API_HOST === 'https://api.partipost.com';
var PROFILE_REQUIREMENT = {
    AGE: 'age',
    GENDER: 'gender',
    INSTAGRAM: 'instagram',
    FACEBOOK: 'facebook',
    TWITTER: 'twitter',
    TIKTOK: 'tiktok',
    LOCATION: 'location',
    MARITAL_STATUS: 'maritalStatus',
    OCCUPATION: 'occupation',
    CONTENT_TYPE: 'contentType',
    CAMPAIGN_HISTORY: 'campaignHistory',
};
export { isProduction, SOCIAL_MEDIA_PLATFORM, EXCLUDED_PROFILING_SOCIAL_MEDIA_PLATFORM, PROFILE_STEP_TYPE, DEFAULT_COMPLETE_PROFILE_STEP_ORDER, PROFILE_REQUIREMENT, };
